import React from "react";
import styled from "styled-components";
import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react/lib/ChoiceGroup";
import { useIntl } from "react-intl";
import { wizardMessages } from "../messages";

type ChooseConnectionProps = {
  dispatch: (data: any) => void;
};

const ChooseConnection = ({ dispatch }: ChooseConnectionProps) => {
  const intl = useIntl();

  const handleChangeConfig = (key: string) => {
    dispatch({
      type: "update",
      payload: {
        form: "creationForm",
        data: {
          credentialUsage: key,
        },
      },
    });
  };

  const options: IChoiceGroupOption[] = [
    {
      key: "managedServiceAccount",
      text: intl.formatMessage(wizardMessages.connectionGmsaOption),
      ariaLabel: intl.formatMessage(wizardMessages.connectionGmsaOption),
      onRenderField: (props, render) => {
        return <OptionWrap>{render!(props)}</OptionWrap>;
      },
    },
    {
      key: "userAccount",
      text: intl.formatMessage(wizardMessages.connectionOption),
      ariaLabel: intl.formatMessage(wizardMessages.connectionOption),
      onRenderField: (props, render) => {
        return <OptionWrap>{render!(props)}</OptionWrap>;
      },
    },
  ];

  return (
    <Wrapper>
      <Title>
        <p className="title-text">{intl.formatMessage(wizardMessages.connectionFormTitle)}</p>
        <span>*</span>
      </Title>
      <ChoiceGroup
        defaultSelectedKey="userAccount"
        options={options}
        onChange={(_, option) => handleChangeConfig(option?.key || "userAccount")}
      />
    </Wrapper>
  );
};

const OptionWrap = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  .title-text {
    margin: 0;
    font-weight: 600 !important;
  }

  span {
    color: ${(props) => props.theme.cayoTheme.brandColors.error};
  }
`;

export default ChooseConnection;
